/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type BulkVersionUpdatePromptSnippetPathParams = NonNullable<
  operations['bulkVersionUpdatePromptSnippet']['parameters']['path']
>;

export type BulkVersionUpdatePromptSnippetRequestBody = OperationRequestBodyContent<
  operations['bulkVersionUpdatePromptSnippet']
>;

export interface Input extends BulkVersionUpdatePromptSnippetPathParams {
  apiVersion?: string;
  body: BulkVersionUpdatePromptSnippetRequestBody;
}

export async function bulkVersionUpdatePromptSnippet(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST(
    '/internal/projects/{projectKey}/ai-configs/prompt-snippets/{snippetKey}/bulk-version-update',
    {
      params: { path },
      body,
      headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
      signal,
    },
  );
}
